import { render } from "./LineageItem.vue?vue&type=template&id=4971e466&scoped=true"
import script from "./LineageItem.vue?vue&type=script&lang=js"
export * from "./LineageItem.vue?vue&type=script&lang=js"

import "./LineageItem.vue?vue&type=style&index=0&id=4971e466&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4971e466"]])

export default __exports__